// extracted by mini-css-extract-plugin
export default {"container":"PreschoolConcepts_container__p1BTr","concepts":"PreschoolConcepts_concepts__GOBjk","concept":"PreschoolConcepts_concept__oM-c3"};